import type { Dictionary } from '../LocalizationProvider.types';

export const getShortMonthNames = (dict: Dictionary) => [
  dict['month-january-short'],
  dict['month-february-short'],
  dict['month-march-short'],
  dict['month-april-short'],
  dict['month-may-short'],
  dict['month-june-short'],
  dict['month-july-short'],
  dict['month-august-short'],
  dict['month-september-short'],
  dict['month-october-short'],
  dict['month-november-short'],
  dict['month-december-short'],
];
